// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"818":"96a046ab","959":"20e26535"}[chunkId] + ".js";
};